define(function () {
    'use strict';

    return function($rootScope){
        return {
            Validate : function(value) {
                if(this.Cif(value)) return true;
                if(this.Nie(value)) return true;
                if(this.Nif(value)) return true;

                return;
            },
            Cif: function(value){
                let regExp = new RegExp("^[a-zA-Z]{1}\\d{7}[a-jA-J0-9]{1}$");
                return regExp.exec(value) ? true : false;
            },
            Nie: function(value){
                let regExp = new RegExp("^[XYZ]?\\d{5,8}[a-zA-Z]{1}$");
                let checkCharacters = "TRWAGMYFPDXBNJZSQVHLCKET";

                /* Check expression */
                let valid = regExp.exec(value) ? true : false;
                if (!valid) return false;
                let nie_prefix = value.charAt(0);
                switch (nie_prefix) {
                    case 'X':
                        nie_prefix = 0;
                        break;
                    case 'Y':
                        nie_prefix = 1;
                        break;
                    case 'Z':
                        nie_prefix = 2;
                        break;
                }

                /* Check character */
                let number = nie_prefix + value.substr(1, value.length - 2);
                let character = value.substr(value.length - 1, 1).toUpperCase();
                let validCharacter = checkCharacters.substr(parseInt(number) % 23, 1);
                if (character != validCharacter) return false;
                return true;
            },
            Nif: function(value){
                let regExp = new RegExp("^\\d{8}[a-zA-Z]{1}$");
                let checkCharacters = "TRWAGMYFPDXBNJZSQVHLCKET";

                /* Check expression */
                let valid = regExp.exec(value) ? true : false;
                if (!valid) return false;

                /* Check character */
                let number = value.substr(0, value.length - 1);
                let character = value.substr(value.length - 1, 1).toUpperCase();
                let validCharacter = checkCharacters.substr(parseInt(number) % 23, 1);
                if (character != validCharacter) return false;

                return true;
            }
        }
    }
});


/** WEBPACK FOOTER **
 ** ./js/services/cif.js
 **/